<script>
import axios from "axios";
import SubscribeSuccess from "./../analytics/SubscribeSuccess";

export default {
    mixins: [SubscribeSuccess],
    data() {
        return {
            email: '',
            message: '',
            success: false
        }
    },
    methods: {
        send(){
            if(this.email.length > 0) {
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/email-subscription/add",
                    data: { email: this.email }
                })
                .then(response => {
                    if(response.data.status == 'success') {
                        this.success = true;

                        // Analytics by mixin SubscribeSuccess
                        this.pushDataSubscribe();
                    }
                    this.message = response.data.message;
                })
                .catch(error => {
                    console.log(error);
                });
            }
        }
    }
}
</script>
